var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "article-preview u-reset article-preview--link" },
    [
      _c("div", { staticClass: "article-preview--row " }, [
        _c(
          "div",
          { staticClass: "article-preview--content article-preview--col" },
          [
            _c("div", [
              _c(
                "div",
                { staticClass: "u-reset article-preview--title" },
                [_vm._t("title", [_vm._v(_vm._s(_vm.title))])],
                2
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "u-reset article-preview--description" },
                [_vm._t("description", [_vm._v(_vm._s(_vm.description))])],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "article-preview--date" },
              [_vm._t("date", [_vm._v(_vm._s(_vm.date))])],
              2
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "article-preview--visual article-preview--col" },
          [
            _c("dyn-aspect-ratio-image", {
              attrs: { "image-url": _vm.image.urls.default[0] }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d035bdf", { render: render, staticRenderFns: staticRenderFns })
  }
}